import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'

import styles from './index.module.css'
import { Button, message, Select, Checkbox } from 'antd'
import UploadDragImage from '../UploadDragImage'
import { actionCreators } from '../../store';
import ModalImageView from '../../../../common/ModalImageView'


function SearchImage() {
    const dispatch = useDispatch()
    const [fileList, setFileList] = useState([]);
    const [imagePreview, setImagePreview] = useState(null);
    const [creating, setCreating] = useState(false);
    let image_data = useSelector(state => state.get('image').get('image_data'))
    let search_time = useSelector(state => state.get('image').get('search_time'))
    const [isImageModalOpen, setIsImageModalOpen] = useState(false)
    const [showImageUrl, setShowImageUrl] = useState('')
    const [sortType, setSortType] = useState('other')
    const [algorithmType, setAlgorithmType] = useState('lab')
    const [isInternal, setIsInternal] = useState(false)

    const handleSubmit = () => {
        console.log("fileList = ", fileList);
        console.log("imagePreview = ", imagePreview);
        if (imagePreview) {
            let formData = new FormData();
            formData.append('image', fileList[0].originFileObj)
            formData.append('is_internal', isInternal)
            formData.append('sort_type', sortType)
            if (sortType === 'color') {
                formData.append('color_similarity_alg', algorithmType)
            }
            setCreating(true)
            dispatch(actionCreators.imageSearchSimilar(formData))
                .then(() => {message.success("数据获取成功")})
                .catch(() => {})
                .finally(() => {setCreating(false)})
        } else {
            message.info("请先上传图片！")
        }
    }

    const handleShowImage = (url) => {
        setIsImageModalOpen(true)
        setShowImageUrl(url)
    }

    return (
        <div className={styles.main}>
            <div className={styles.container}>
                <div className={styles.container_left}>
                    <div className={styles.container_item_header}>拖入想查询的贴图</div>
                    <div className={styles.container_left_content}>
                        <UploadDragImage
                            fileList={fileList}
                            setFileList={setFileList}
                            imagePreview={imagePreview}
                            setImagePreview={setImagePreview}
                        />
                    </div>
                </div>
                <div className={styles.container_middle}>
                    <div className={styles.check_box}>
                        <Checkbox
                            defaultChecked={isInternal}
                            value={isInternal}
                            onChange={() => {setIsInternal(!isInternal)}}
                        >
                            是否内网搜索？
                        </Checkbox>
                    </div>

                    <div className={styles.search_type_box}>
                        <div className={styles.sort_type_box}>
                            <div className={styles.search_type_title}>排序方式：</div>
                            <Select
                                defaultValue={sortType}
                                style={{
                                    width: '100%',
                                }}
                                onChange={(value) => {setSortType(value)}}
                                options={[
                                    {
                                        value: 'other',
                                        label: '纹理',
                                    },
                                    {
                                        value: 'color',
                                        label: '颜色',
                                    },
                                ]}
                            />
                        </div>

                        {
                            sortType === 'color' ? (
                                <div className={styles.algorithm_type_box}>
                                    <div className={styles.search_type_title}>颜色算法类型：</div>
                                    <Select
                                        defaultValue={algorithmType}
                                        style={{
                                            width: '100%',
                                        }}
                                        onChange={(value) => {setAlgorithmType(value)}}
                                        options={[
                                            {
                                                value: 'lab',
                                                label: 'Lab颜色空间',
                                            },
                                            // {
                                            //     value: 'ssim',
                                            //     label: '结构化相似度',
                                            // },
                                            {
                                                value: 'combined_feature',
                                                label: '颜色标准差和平均颜色的综合特征',
                                            },
                                        ]}
                                    />
                                </div>
                            ) : null
                        }
                    </div>

                    {
                        creating ? (
                            <Button type="primary" loading>
                                查询中...
                            </Button>
                        ) : (
                            <Button
                                type="primary"
                                onClick={handleSubmit}
                            >
                                查询
                            </Button>
                        )
                    }
                </div>
                <div className={styles.container_right}>
                    <div className={styles.container_item_header}>查询结果 {search_time === 0 ? '' : `（查询时间${search_time}s）`}</div>
                    <div className={styles.container_right_content}>
                        {
                            image_data.toJS().map((item) => {
                                let item_metadata = item?.kwargs?.metadata

                                return (
                                    <div
                                        className={styles.item_box}
                                        key={item_metadata?.id}
                                    >
                                        <div className={styles.item_percent}>{item_metadata?.score}</div>
                                        <div className={styles.item_img_box}>
                                            <img
                                                src={item_metadata?.url}
                                                className={styles.item_img}
                                                alt="img"
                                                onClick={() => {handleShowImage(item_metadata?.url)}}
                                            />
                                        </div>
                                        <div className={styles.item_text_box}>
                                            <div className={styles.item_text_name}>名字：{item_metadata?.name}</div>
                                            <div className={styles.item_text_category}>类别：{item_metadata?.meta_data?.primary}-{item_metadata?.meta_data?.secondary}</div>
                                            {/* <div className={styles.item_text_brand}>品牌：{item.brand}</div> */}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>

            <ModalImageView
                isModalOpen={isImageModalOpen}
                setIsModalOpen={setIsImageModalOpen}
                showImageUrl={showImageUrl}
                setShowImageUrl={setShowImageUrl}
            />
        </div>
    )
}

export default SearchImage